import React, { useEffect, useState } from "react";
import _ from 'lodash'
import ThemedCalendarStrip from 'components/atoms/ThemedCalendarStrip'
import FetchBooking from 'utils/fetch/FetchBooking'
import HelperCollection from 'utils/helper-collection'
import ObjectBooking from 'utils/objects/booking'
import HelperString from 'utils/helper-string'
import FetchTimeslotCapacity from 'utils/fetch/FetchTimeslotCapacity'
import Timeslot from 'components/molecules/Timeslot'
import { ScannedInText } from 'components/atoms/EmployeeScan'
import HelperDate, { dateFormat } from 'utils/helper-date'

const EmployeeCalendar = ({ employee }) => {
	
	const [ loading, setLoading ] = useState( false )
	const [ bookings, setBookings ] = useState( {} )
	
	const [ date, setDate ] = useState( HelperDate.date() )
	const [ dateFetched, setDateFetched ] = useState( null )
	
	const fetchBookings = () => {
		if( dateFetched !== null && dateFetched.isSame( date, 'day' ) ) {
			return;
		}
		
		setDateFetched( date )
		
		// Create from <-> till
		const dateRange = {
			from: date.startOf('month').format( dateFormat.DATE ),
			till: date.endOf('month').format( dateFormat.DATE ),
		}
		
		FetchBooking.fetch( dateRange, {
			employeeGuid: employee?.guid,
			callbackStart: setLoading.bind( this, true ),
			callbackError: setLoading.bind( this, false ),
			callbackSuccess: ( result ) => {
				const fetchedBookings = ObjectBooking.prepareForRedux( HelperCollection.filterWithoutGuid(
					_.get( result, ['bookings'], [] )
				) );
				
				setBookings({
					...bookings,
					...fetchedBookings
				})
				setLoading( false )
			}
		});
	}
	
	useEffect( () => {
		return fetchBookings();
	}, [ date ] )
	
	useEffect( () => {
		setDateFetched( null )
	}, [ employee ] );
	
	return (
		<ThemedCalendarStrip
			key={ "calendar-strip" }
			employee={ employee }
			onSelect={ setDate }
			bookings={ bookings }
			showEmployee={ true }
			showLunchOptions={ false }
			showBuildingParkingSpace={ false }
			withActions={ false }
			date={ date }
			isLoading={ loading }
			renderItem={ ( item ) => {
				const scan = _.get( item, 'employee_scan', {} );
				
				return (
					<Timeslot
						key={ HelperString.hash( 'calendar-list-item', FetchTimeslotCapacity.keyByBooking( item ) ) }
						item={ item }>
						
						<ScannedInText
							item={ scan }
						/>
					</Timeslot>
				)
			}}
		/>
	)
}

export default EmployeeCalendar
